const requireAuthentication = ({ rootState }) => {
  if (!rootState.auth.isAuthenticated || !rootState.auth.user) {
    throw new Error('Access denied')
  }
}

export default requireAuthentication
